import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import {
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
  Polyline,
  //useJsApiLoader,
} from "@react-google-maps/api";
import {
  Autocomplete,
  CheckBox,
  DateBox,
  NumberBox,
  Template,
  TextBox,
} from "devextreme-react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { AssetSubStatus, DefaultDateFormat } from "../../../helper/fixcode";
import { assetService } from "../../../apis/apiServices/Asset";
import { Link, useNavigate } from "react-router-dom";
import "./../../../App.css";
import { useSelector } from "react-redux";
import moment from "moment";
import Modal from "react-modal";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  askConfirmation,
  showErrorMessage,
  showResponseMessage,
  showWarningMessage,
} from "../../../helper/message";
import TabPanel, { Item } from "devextreme-react/tab-panel";
import axios from "axios";
import { Loader } from "../../Shared/PageLoader";

const containerStyle = {
  width: "100%",
  height: "400px",
};

// const libraries = ["places"];

export default function AssetDispatchComponent(props) {
  const [state, setState] = useState({
    isStatusUpdated: false,
    isStatusUpdateModalOpen: false,
    isTrackingModalOpen: false,
    isSelected: false,
    isSubmitted: false,
    isReSubmitted: false,
    rowData: null,
    jobDate: null,
    fromCoords: 0,
    toCoords: 0,
    selectedTabIndex: 0,
    vehicleNo: "",
    currentLocationResult: [],
    currentLocation: "",
    currentLocationGeoCode: "",
    fromLocationResult: [],
    fromLocation: "",
    fromLocationGeoCode: "",
    toLocationResult: [],
    toLocation: "",
    toLocationGeoCode: "",
    lastKm: 0,
    totalKm: 0,
    eta: new Date(),
    entryTime: new Date(),
    isCompleteLoading: false,
    loadingMessage: "",
  });
  const [errors, setErrors] = useState({
    jobDateValidation: "",
    currentLocationValidation: "",
    fromLocationValidation: "",
    toLocationValidation: "",
    lastKmValidation: "",
    totalKmValidation: "",
    etaValidation: "",
    entryTimeValidation: "",
  });
  const [assetDispatchDataSourceLst, setAssetDispatchDataSourceLst] = useState(
    []
  );
  const [arrowPoints, setArrowPoints] = useState([]);
  const [activeMarker, setActiveMarker] = useState(null);
  const [activeMarkerInfo, setActiveMarkerInfo] = useState(null);
  const [isClickOnTotalKm, setIsClickOnTotalKm] = useState(false);
  const [isClickOnEtaDate, setIsClickOnEtaDate] = useState(false);
  const refDataGrid = useRef(null);
  const user = useSelector((state) => state.user.data);
  const [isOpen, setIsOpen] = useState(false);
  const [dispatchTripDetails, setDispatchTripDetails] = useState([]);

  // const { isLoaded } = useJsApiLoader({
  //   id: "google-map-script",
  //   googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
  //   libraries,
  // });

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Asset Dispatch`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));
      await getAssetDispatchLst(0, user?.userId);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    } catch (error) {
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  }, []);

  const getAssetDispatchLst = async (assetDispatchId, userId) => {
    try {
      //refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await assetService.getAssetDispatch(
        assetDispatchId,
        userId
      );
      setAssetDispatchDataSourceLst(
        response.data?.filter(
          (f) => f.statusId !== Number(AssetSubStatus.AssetDispatchJobEnded)
        ) ?? []
      );
    } catch (error) {
      console.log(error);
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  const getDispatchTripDetails = async (dispatchId) => {
    try {
      const response = await assetService.getDispatchTripDetails(dispatchId);
      setDispatchTripDetails(response.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const isValidStatusData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.jobDateValidation = "";
      if (state.isSelected && !state.jobDate) {
        isValid = false;
        err.jobDateValidation = `${
          state.rowData?.statusId ===
          Number(AssetSubStatus.AssetDispatchPending)
            ? "Please select job start date."
            : state.rowData?.statusId ===
              Number(AssetSubStatus.AssetDispatchJobStarted)
            ? "Please select job end date."
            : ""
        }`;
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnUpdateStatus = async (e) => {
    e.preventDefault();
    try {
      if (isValidStatusData()) {
        debugger;
        let confirmationQuestion = `<span style='font-size:16px;'>${
          state.rowData?.statusId ===
          Number(AssetSubStatus.AssetDispatchPending)
            ? `Are you sure you want to start the job for asset dispatch [${state.rowData?.dispatchIndentNo}]?`
            : state.rowData?.statusId ===
              Number(AssetSubStatus.AssetDispatchJobStarted)
            ? `Are you sure you want to end the job for asset dispatch [${state.rowData?.dispatchIndentNo}]?`
            : ``
        }</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isStatusUpdated: true }));
        let body = {
          assetDispatchId: state?.rowData?.id,
          jobDate:
            moment(state.jobDate)
              .format(DefaultDateFormat.SqlDateTime24Format)
              .toString() ?? "",
          userId: user?.userId,
        };
        const response = await assetService.updateAssetDispatchStatus(body);
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isStatusUpdated: false }));
        if (response?.isSuccess) {
          handleOnCloseStatusUpdateModal();
          setState((prevState) => ({
            ...prevState,
            isCompleteLoading: true,
          }));
          await getAssetDispatchLst(0, user?.userId);
          setState((prevState) => ({
            ...prevState,
            isCompleteLoading: false,
          }));
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isStatusUpdated: false }));
      console.log(error);
    }
  };

  const handleOnCloseStatusUpdateModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isStatusUpdateModalOpen: false,
        rowData: null,
        jobDate: null,
        isStatusUpdated: false,
        isSelected: false,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnCloseTrackingModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isTrackingModalOpen: false,
        rowData: null,
        selectedTabIndex: 0,
        vehicleNo: "",
        currentLocation: "",
        currentLocationGeoCode: "",
        fromLocation: "",
        fromLocationGeoCode: "",
        toLocation: "",
        toLocationGeoCode: "",
        lastKm: 0,
        totalKm: 0,
        eta: new Date(),
        entryTime: new Date(),
        currentLocationResult: [],
        fromLocationResult: [],
        toLocationResult: [],
      }));
      setIsClickOnEtaDate(false);
      setIsClickOnTotalKm(false);
    } catch (error) {
      console.log(error);
    }
  };

  const isValidDispatchDetailsData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.currentLocationValidation = "";
      err.fromLocationValidation = "";
      err.toLocationValidation = "";
      err.lastKmValidation = "";
      err.totalKmValidation = "";
      err.etaValidation = "";
      err.entryTimeValidation = "";
      let fl = dispatchTripDetails[0]?.fromDispatchLocation || "";
      let tl = dispatchTripDetails[0]?.toDispatchLocation || "";
      let lk = dispatchTripDetails[0]?.lastKms || 0;
      if (fl && tl && !state.currentLocation) {
        isValid = false;
        err.currentLocationValidation = "Please enter current location.";
      }
      if (!state.fromLocation) {
        isValid = false;
        err.fromLocationValidation = "Please enter from location.";
      }
      if (!state.toLocation) {
        isValid = false;
        err.toLocationValidation = "Please enter to location.";
      }
      if (lk > 0) {
        if (state.lastKm === 0 || !state.lastKm) {
          isValid = false;
          err.lastKmValidation = "Please enter last km.";
        }
      }
      if (state.totalKm === 0 || !state.totalKm) {
        isValid = false;
        err.totalKmValidation = "Please enter total km.";
      }
      if (!state.eta) {
        isValid = false;
        err.etaValidation = "Please select eta.";
      }
      if (!state.entryTime) {
        isValid = false;
        err.entryTimeValidation = "Please select entry time.";
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const isValidRsubmitDispatchDetailsData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.totalKmValidation = "";
      err.etaValidation = "";
      if (state.totalKm === 0 || !state.totalKm) {
        isValid = false;
        err.totalKmValidation = "Please enter total km.";
      }
      if (!state.eta) {
        isValid = false;
        err.etaValidation = "Please select eta.";
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnSaveDispatchDetails = async (e) => {
    e.preventDefault();
    try {
      if (state.totalKm > 0 && dispatchTripDetails[0]?.etaDate) {
        if (new Date(state.entryTime.toString()) > new Date(state.eta)) {
          await showWarningMessage(`Please add entry time less than ETA date`);
          return;
        }
      }
      if (state.totalKm > 0) {
        const totalLastKms = dispatchTripDetails.reduce(
          (sum, item) => sum + (item.lastKms || 0),
          0
        );
        const remainingKms = state.totalKm - totalLastKms;
        if (remainingKms === 0) {
          await showWarningMessage(
            `Vehicle [${state.rowData?.transportVehicle}] is already completed ${state.totalKm} Km.`
          );
          return;
        }
        if (remainingKms > 0 && state.lastKm > remainingKms) {
          await showWarningMessage(
            `Please enter last km travelled less than ${remainingKms}`
          );
          return;
        }
      }
      let prevRecord = null;
      if (dispatchTripDetails?.length > 0) {
        prevRecord = dispatchTripDetails[dispatchTripDetails?.length - 1];
      }

      if (isValidDispatchDetailsData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>Are you sure you want to save dispatch details for [${state.rowData?.dispatchIndentNo}]?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSubmitted: true }));
        let body = {
          dispatchId: state.rowData?.id ?? 0,
          vehicleNo: state.vehicleNo ?? "",
          currentLocation: state.currentLocation ?? "",
          currentGeoLocation: state.currentLocationGeoCode
            ? state.currentLocationGeoCode
            : dispatchTripDetails[0]?.currentGeoLocation,
          fromLocation: state.fromLocation
            ? state.fromLocation
            : dispatchTripDetails[0]?.fromDispatchLocation,
          fromGeoLocation: state.fromLocationGeoCode
            ? state.fromLocationGeoCode
            : dispatchTripDetails[0]?.fromGeoLocation,
          toLocation: state.toLocation
            ? state.toLocation
            : dispatchTripDetails[0]?.toDispatchLocation,
          toGeoLocation: state.toLocationGeoCode
            ? state.toLocationGeoCode
            : dispatchTripDetails[0]?.toGeoLocation,
          lastKm: state.lastKm ?? 0,
          totalKm:
            state.totalKm > 0
              ? state.totalKm
              : dispatchTripDetails[0]?.totalKms,
          eta: state.eta
            ? moment(state.eta)
                .format(DefaultDateFormat.SqlDateTime24Format)
                ?.toString()
            : "",
          entryTime: state.entryTime
            ? moment(state.entryTime)
                .format(DefaultDateFormat.SqlDateTime24Format)
                ?.toString()
            : "",
          userId: user?.userId ?? 0,
          prevDispatchId: prevRecord?.id ?? 0,
        };
        const response = await assetService.addDispatchDetails(body);
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isSubmitted: false }));
        if (response?.isSuccess) {
          handleOnCloseTrackingModal();
          setState((prevState) => ({
            ...prevState,
            isCompleteLoading: true,
          }));
          await getAssetDispatchLst(0, user?.userId);
          setState((prevState) => ({
            ...prevState,
            isCompleteLoading: false,
          }));
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSubmitted: false }));
      console.log(error);
    }
  };

  const handleOnResubmitDispatchDetails = async (e) => {
    e.preventDefault();
    try {
      debugger;
      if (isValidRsubmitDispatchDetailsData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to update total km & eta for dispatch [${state.rowData?.dispatchIndentNo}]?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isReSubmitted: true }));
        let body = {
          dispatchId: state.rowData?.id ?? 0,
          totalKm: state.totalKm,
          etaDate: state.eta
            ? moment(state.eta)
                .format(DefaultDateFormat.SqlDateTime24Format)
                ?.toString()
            : "",
          userId: user?.userId,
        };
        const response = await assetService.reSubmitDispatchDetails(body);
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isReSubmitted: false }));
        if (response?.isSuccess) {
          await getDispatchTripDetails(state.rowData?.id ?? 0);
          setIsClickOnEtaDate(false);
          setIsClickOnTotalKm(false);
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isReSubmitted: false }));
      console.log(error);
    }
  };

  const getLocationName = async (lat, lng) => {
    const geocoder = new window.google.maps.Geocoder();
    return new Promise((resolve) => {
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          resolve(results[0].formatted_address);
        } else {
          resolve("Unknown Location");
        }
      });
    });
  };

  const handleOnCurrentLocationSearch = async (value) => {
    if (value?.length < 0) return;
    const response = await axios.get(
      `https://maps.gomaps.pro/maps/api/place/textsearch/json?query=${value}&key=${process.env.REACT_APP_GO_MAP_API_KEY}`
    );
    const results =
      response.data.results?.map((p) => ({
        name: p?.name,
        address: p?.formatted_address,
        placeId: p?.place_id,
        lat: p?.geometry?.location?.lat,
        lng: p?.geometry?.location?.lng,
      })) || [];
    let err = { ...errors };
    err.currentLocationValidation = "";
    setErrors(err);
    setState((prev) => ({
      ...prev,
      currentLocationResult: results ?? [],
    }));
  };

  const handleOnCurrentLocationSelection = async (place) => {
    try {
      let rowData = state.currentLocationResult?.filter(
        (f) => f.name + " - " + f.address === place
      )[0];
      // let rowData = state.currentLocationResult?.filter(
      //   (f) => f.address === place
      // )[0];
      const latStr = String(rowData?.lat);
      const lngStr = String(rowData?.lng);
      setState((prev) => ({
        ...prev,
        currentLocation: rowData?.address ?? "",
        currentLocationGeoCode: `${latStr}, ${lngStr}`,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnFromLocationSearch = async (value) => {
    if (value?.length < 0) return;
    const response = await axios.get(
      `https://maps.gomaps.pro/maps/api/place/textsearch/json?query=${value}&key=${process.env.REACT_APP_GO_MAP_API_KEY}`
    );
    const results =
      response.data.results?.map((p) => ({
        name: p?.name,
        address: p?.formatted_address,
        placeId: p?.place_id,
        lat: p?.geometry?.location?.lat,
        lng: p?.geometry?.location?.lng,
      })) || [];
    let err = { ...errors };
    err.fromLocationValidation = "";
    setErrors(err);
    setState((prev) => ({
      ...prev,
      fromLocationResult: results ?? [],
    }));
  };

  const handleOnFromLocationSelection = async (place) => {
    try {
      let rowData = state.fromLocationResult?.filter(
        (f) => f.name + " - " + f.address === place
      )[0];
      // let rowData = state.fromLocationResult?.filter(
      //   (f) => f.address === place
      // )[0];
      const latStr = String(rowData?.lat);
      const lngStr = String(rowData?.lng);
      setState((prev) => ({
        ...prev,
        fromLocation: rowData?.address ?? "",
        fromLocationGeoCode: `${latStr}, ${lngStr}`,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnToLocationSearch = async (value) => {
    if (value?.length < 0) return;
    const response = await axios.get(
      `https://maps.gomaps.pro/maps/api/place/textsearch/json?query=${value}&key=${process.env.REACT_APP_GO_MAP_API_KEY}`
    );
    const results =
      response.data.results?.map((p) => ({
        name: p?.name,
        address: p?.formatted_address,
        placeId: p?.place_id,
        lat: p?.geometry?.location?.lat,
        lng: p?.geometry?.location?.lng,
      })) || [];
    let err = { ...errors };
    err.toLocationValidation = "";
    setErrors(err);
    setState((prev) => ({
      ...prev,
      toLocationResult: results ?? [],
    }));
  };

  const handleOnToLocationSelection = async (place) => {
    try {
      let rowData = state.toLocationResult?.filter(
        (f) => f.name + " - " + f.address === place
      )[0];
      // let rowData = state.toLocationResult?.filter(
      //   (f) => f.address === place
      // )[0];
      const latStr = String(rowData?.lat);
      const lngStr = String(rowData?.lng);
      setState((prev) => ({
        ...prev,
        toLocation: rowData?.address ?? "",
        toLocationGeoCode: `${latStr}, ${lngStr}`,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              ref={refDataGrid}
              keyExpr="id"
              dataSource={assetDispatchDataSourceLst}
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              allowColumnResizing={false}
              allowColumnReordering={true}
              columnAutoWidth={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift({
                  location: "before",
                  template: "toolbarRefreshTemplate",
                });
              }}
            >
              <Column
                dataField="id"
                width={
                  assetDispatchDataSourceLst?.filter(
                    (f) =>
                      f.statusId ===
                        Number(AssetSubStatus.AssetDispatchJobStarted) ||
                      f.statusId === Number(AssetSubStatus.AssetDispatchPending)
                  ).length > 0
                    ? 160
                    : 80
                }
                caption=""
                allowExporting={false}
                allowFiltering={false}
                allowSearch={false}
                allowSorting={false}
                cellRender={(cellData) => {
                  return (
                    <>
                      <div style={{ display: "flex" }}>
                        {(cellData?.data?.momentActionAllowed ||
                          cellData?.data?.momentOrderActionAllowed) && (
                          <span>
                            <button
                              style={{ cursor: "pointer" }}
                              type="button"
                              title="Action"
                              className="btn btn-primary btn-sm-1"
                              onClick={() => {
                                setState((prev) => ({
                                  ...prev,
                                  isStatusUpdateModalOpen: true,
                                  rowData: cellData?.data,
                                  //jobDate: cellData?.data?.startDate,
                                }));
                              }}
                              hidden={
                                cellData?.data?.statusId ===
                                Number(AssetSubStatus.AssetDispatchJobEnded)
                              }
                            >
                              <Icon
                                className="iconify-size mr-1"
                                icon="mdi:call-to-action"
                                width="14"
                                height="14"
                              />
                              &nbsp;
                              {cellData?.data?.statusId ===
                              Number(AssetSubStatus.AssetDispatchPending)
                                ? "Start job"
                                : cellData?.data?.statusId ===
                                  Number(AssetSubStatus.AssetDispatchJobStarted)
                                ? "End Job"
                                : ""}
                            </button>
                          </span>
                        )}
                        &nbsp;&nbsp;
                        <span>
                          <button
                            style={{ cursor: "pointer" }}
                            type="button"
                            title="Track"
                            className="btn btn-primary btn-sm-1"
                            onClick={() => {
                              setState((prev) => ({
                                ...prev,
                                isTrackingModalOpen: true,
                                rowData: cellData?.data,
                                fromCoords: cellData?.data?.fromGeoLocation
                                  ? cellData?.data?.fromGeoLocation
                                      ?.split(",")
                                      .map(Number)
                                  : 0,
                                toCoords: cellData?.data?.toGeoLocation
                                  ? cellData?.data?.toGeoLocation
                                      ?.split(",")
                                      .map(Number)
                                  : 0,
                                fromLocation:
                                  cellData?.data?.fromDispatchLocation ?? "",
                                toLocation:
                                  cellData?.data?.toDispatchLocation ?? "",
                                vehicleNo:
                                  cellData?.data?.transportVehicleNo ?? "",
                                //lastKm: cellData?.data?.lastKms ?? 0,
                                totalKm: cellData?.data?.totalKms ?? 0,
                                eta: cellData?.data?.etaDate
                                  ? cellData?.data?.etaDate
                                  : new Date(),
                              }));
                              let err = { ...errors };
                              err.currentLocationValidation = "";
                              err.fromLocationValidation = "";
                              err.toLocationValidation = "";
                              err.lastKmValidation = "";
                              err.totalKmValidation = "";
                              err.etaValidation = "";
                              err.entryTimeValidation = "";
                              setErrors(err);
                            }}
                            hidden={
                              cellData?.data?.statusId ===
                              Number(AssetSubStatus.AssetDispatchPending)
                            }
                          >
                            <i
                              className="fas fa-map-marked-alt"
                              style={{
                                width: "14px",
                                height: "12px",
                                marginTop: "5px",
                              }}
                            ></i>
                            &nbsp;
                            {`${
                              cellData?.data?.statusId ===
                              Number(AssetSubStatus.AssetDispatchPending)
                                ? "Track"
                                : cellData?.data?.statusId ===
                                  Number(AssetSubStatus.AssetDispatchJobStarted)
                                ? "Replay"
                                : ""
                            }`}
                          </button>
                        </span>
                      </div>
                    </>
                  );
                }}
              />
              <Column
                dataField="movementIndentNo"
                caption="Asset Movement No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="dispatchIndentNo"
                caption="Asset Dispatch No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="assetRequestSubNo"
                caption="Asset Request No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="dispatchDate"
                caption="Dispatch Date"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                dataType="date"
                format={DefaultDateFormat.GridDayMonthYearDateFormat}
              />
              <Column
                dataField="statusName"
                caption="Status"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(e) => {
                  let color = "#28A745";
                  if (
                    e.data?.statusId ===
                    Number(AssetSubStatus.AssetDispatchPending)
                  ) {
                    color = "#afad1eff";
                  } else if (
                    e.data?.statusId ===
                    Number(AssetSubStatus.AssetDispatchJobStarted)
                  ) {
                    color = "#16b36aff";
                  } else if (
                    e.data?.statusId ===
                    Number(AssetSubStatus.AssetDispatchJobStarted)
                  ) {
                    color = "#c50a23ff";
                  }

                  var lastUpdatedDate = "";
                  if (!e?.data?.updatedDate) {
                    lastUpdatedDate = moment(e?.data?.createdDate)
                      .format(
                        DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat
                      )
                      .toString();
                  } else {
                    const parsedDate = new Date(e?.data?.updatedDate);
                    if (isNaN(parsedDate.getTime())) {
                      lastUpdatedDate = moment(e?.data?.updatedDate)
                        .format(
                          DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat
                        )
                        .toString();
                    }
                    const minDate = new Date("0001-01-01T00:00:00");
                    if (parsedDate.getTime() === minDate.getTime()) {
                      lastUpdatedDate = moment(e?.data?.createdDate)
                        .format(
                          DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat
                        )
                        .toString();
                    } else {
                      lastUpdatedDate = moment(e?.data?.updatedDate)
                        .format(
                          DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat
                        )
                        .toString();
                    }
                  }
                  return (
                    <div>
                      <span style={{ color }}>{e.data?.statusName}</span>
                      <br />
                      <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                        {lastUpdatedDate}
                      </div>
                    </div>
                  );
                }}
              />
              <Column
                dataField="allocatedAssetName"
                caption="Asset Description"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.allocatedAssetName || ""} ${
                    data?.allocatedAssetSerialNo || ""
                  } ${data?.materialOrderDesc || ""}`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      {data?.data?.materialOrderDesc ? (
                        <>
                          <span>{data?.data?.materialOrderDesc ?? ""}</span>
                        </>
                      ) : (
                        <>
                          <span>{data?.data?.allocatedAssetName ?? ""}</span>
                          {data?.data?.allocatedAssetSerialNo && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.allocatedAssetSerialNo ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="categoryName"
                caption="Category"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.categoryName || ""} ${
                    data?.subCategoryName || ""
                  } ${data?.orderSubCategory || ""} ${
                    data?.orderCategory || ""
                  }`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      {data?.data?.orderSubCategory &&
                      data?.data?.orderCategory ? (
                        <>
                          <span>{data?.data?.orderCategory ?? ""}</span>
                          {data?.data?.orderSubCategory && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.orderSubCategory ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <span>{data?.data?.categoryName ?? ""}</span>
                          {data?.data?.subCategoryName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.subCategoryName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="fromUserFullName"
                caption="From"
                visible={false}
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.fromUserFullName || ""} ${
                    data?.fromUserFullName || ""
                  }`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.fromUserFullName ?? ""}</span>
                      {data?.data?.fromDepartment && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.fromDepartment ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="toUserFullName"
                caption="To"
                visible={false}
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.toUserFullName || ""} ${
                    data?.toDepartment || ""
                  }`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.toUserFullName ?? ""}</span>
                      {data?.data?.toDepartment && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.toDepartment ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="fromProjectName"
                caption="Project"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.fromProjectName || ""} ${
                    data?.toProjectName || ""
                  } ${data?.materialOrderLocation || ""}`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      {data?.data?.materialOrderLocation ? (
                        <>
                          <span>{data?.data?.materialOrderLocation ?? ""}</span>
                        </>
                      ) : (
                        <>
                          <span>{data?.data?.fromProjectName ?? ""}</span>
                          {data?.data?.toProjectName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toProjectName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="transportationName"
                caption="Transportation Type"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="transportVehicle"
                caption="Vehicle No."
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="transportVendorName"
                caption="Vendor Name"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              {/* <Column
                dataField="createdDate"
                caption="Created On"
                allowSearch={true}
                allowFiltering={false}
                calculateCellValue={(data) => {
                  return `${data?.createdDate || ""} ${
                    data?.createdByUserFullName || ""
                  }`;
                }}
                cellRender={(data) => {
                  if (data?.data?.createdDate) {
                    return (
                      <>
                        <span>
                          {moment(data?.data?.createdDate).format(
                            "DD/MM/YYYY"
                          ) +
                            " " +
                            moment(data?.data?.createdDate).format("LT") ?? ""}
                        </span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.createdByUserFullName ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="updatedDate"
                caption="Last updated"
                allowSearch={true}
                allowFiltering={false}
                calculateCellValue={(data) => {
                  return `${data?.updatedDate || ""} ${
                    data?.updatedByUserFullName || ""
                  }`;
                }}
                cellRender={(data) => {
                  if (data?.data?.updatedDate) {
                    return (
                      <>
                        <span>
                          {moment(data?.data?.updatedDate).format(
                            "DD/MM/YYYY"
                          ) +
                            " " +
                            moment(data?.data?.updatedDate).format("LT") ?? ""}
                        </span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.updatedByUserFullName ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              /> */}
              <Template
                name="toolbarRefreshTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Refresh"
                        className="btn btn-outline-primary btn-sm"
                        onClick={async () => {
                          try {
                            setState((prevState) => ({
                              ...prevState,
                              isCompleteLoading: true,
                            }));
                            await getAssetDispatchLst(0, user?.userId);
                          } catch (error) {
                            console.log(error);
                          } finally {
                            setState((prevState) => ({
                              ...prevState,
                              isCompleteLoading: false,
                            }));
                          }
                        }}
                      >
                        <i className="fas fa-sync-alt"></i>
                        &nbsp;&nbsp;Refresh
                      </button>
                    </>
                  );
                }}
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={10} />
              <Pager
                allowedPageSizes={[10, 15, 20, 50, 100]}
                // displayMode="compact"
                showPageSizeSelector={true}
                showInfo={true}
                visible={true}
                showNavigationButtons={true}
              />
              <Export enabled={true} fileName="Asset Dispatch" />
            </DataGrid>
          </div>
        </div>
      </div>

      {/* For Updating Status For Asset Dispatch */}
      <Modal
        ariaHideApp={false}
        isOpen={state.isStatusUpdateModalOpen}
        onAfterOpen={async () => {
          let err = { ...errors };
          err.jobDateValidation = "";
          setErrors(err);
        }}
        className={"react-modal custom-modal-medium"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Update Status For Asset Dispatch"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {`Update Status For Asset Dispatch - [${state.rowData?.dispatchIndentNo}]`}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseStatusUpdateModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="form-group mb-2">
                <CheckBox
                  value={state?.isSelected}
                  text={`${
                    state.rowData?.statusId ===
                    Number(AssetSubStatus.AssetDispatchPending)
                      ? "Is Job Started?"
                      : state.rowData?.statusId ===
                        Number(AssetSubStatus.AssetDispatchJobStarted)
                      ? "Is Reached At Destination?"
                      : ""
                  }`}
                  disabled={false}
                  onValueChanged={(e) => {
                    setState((prev) => ({
                      ...prev,
                      isSelected: e.value ?? false,
                    }));
                  }}
                />
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            {state.rowData?.statusId ===
              Number(AssetSubStatus.AssetDispatchJobStarted) && (
              <>
                <div className="col-12 col-lg-6">
                  <div className="form-group mb-2">
                    <label>Job Start Date</label>
                    <DateBox
                      type="datetime"
                      className="form-control"
                      name="jobDate"
                      placeholder={DefaultDateFormat.DateTime24Format}
                      displayFormat={DefaultDateFormat.DateTime24Format}
                      showAnalogClock={true}
                      useMaskBehavior={false}
                      defaultValue={state.rowData?.startDate}
                      value={state.rowData?.startDate}
                      disabled={false}
                      readOnly={true}
                      acceptCustomValue={true}
                    />
                  </div>
                </div>
              </>
            )}
            <div
              className={`col-12 col-lg-${
                state.rowData?.statusId ===
                Number(AssetSubStatus.AssetDispatchJobStarted)
                  ? 6
                  : 12
              }`}
            >
              <div className="form-group mb-2">
                <label>
                  {`${
                    state.rowData?.statusId ===
                    Number(AssetSubStatus.AssetDispatchPending)
                      ? "Job Start Date"
                      : state.rowData?.statusId ===
                        Number(AssetSubStatus.AssetDispatchJobStarted)
                      ? "Job End Date"
                      : ""
                  }
                  `}
                  &nbsp;<span className="text-danger">*</span>
                  <DateBox
                    type="datetime"
                    className="form-control"
                    name="jobDate"
                    placeholder={DefaultDateFormat.DateTime24Format}
                    displayFormat={DefaultDateFormat.DateTime24Format}
                    showAnalogClock={true}
                    useMaskBehavior={false}
                    defaultValue={state.jobDate}
                    value={state.jobDate}
                    min={
                      state.rowData?.statusId ===
                      Number(AssetSubStatus.AssetDispatchPending)
                        ? moment(state.rowData?.movementApprovalDate).toDate()
                        : state.rowData?.statusId ===
                          Number(AssetSubStatus.AssetDispatchJobStarted)
                        ? moment(state.rowData?.startDate).toDate()
                        : 0
                    }
                    max={moment(new Date()).toDate()}
                    disabled={false}
                    acceptCustomValue={true}
                    onValueChanged={(date) => {
                      setState((prev) => ({
                        ...prev,
                        jobDate: date.value,
                      }));
                    }}
                  />
                </label>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            {state.isSelected && (
              <>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  title="Update"
                  onClick={async (e) => {
                    await handleOnUpdateStatus(e);
                  }}
                  disabled={state.isStatusUpdated}
                >
                  <span title="Update">
                    <i
                      className={`fas fa-${
                        state.isStatusUpdated ? `spinner fa-spin` : `check`
                      }`}
                    />
                    &nbsp;&nbsp;Update
                  </span>
                </button>
                &nbsp;&nbsp;
              </>
            )}
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              title="Cancel"
              onClick={() => {
                handleOnCloseStatusUpdateModal();
              }}
            >
              <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        ariaHideApp={false}
        isOpen={state.isTrackingModalOpen}
        onAfterOpen={async () => {
          await getDispatchTripDetails(state.rowData?.id);
        }}
        className={"react-modal custom-modal-xlarge"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Tracking Vehicle For Asset Dispatch"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {`Tracking vehicle - [${state.rowData?.transportVehicle}] - for asset dispatch - [${state.rowData?.dispatchIndentNo}]`}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseTrackingModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <TabPanel
            loop={true}
            width={"100%"}
            height={"80%"}
            animationEnabled={true}
            swipeEnabled={false}
            tabsPosition={"top"}
            stylingMode={"secondary"}
            iconPosition={"top"}
            //itemComponent={TabPanelItem}
            selectedIndex={state.selectedTabIndex}
            onSelectedIndexChange={(index) => {
              try {
                setState((prev) => ({ ...prev, selectedTabIndex: index }));
              } catch (error) {
                console.log(error);
              }
            }}
          >
            <Item title="View Dispatch Details" icon="map">
              <>
                <div className="row content-header">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="row">
                      <div className="col-12 col-lg-4">
                        <div className="form-group mb-2">
                          <label className="mb-0">From Location</label>
                          <p className="labelvalue">
                            {state.rowData?.fromDispatchLocation ?? "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-4">
                        <div className="form-group mb-2">
                          <label className="mb-0">To Location</label>
                          <p className="labelvalue">
                            {state.rowData?.toDispatchLocation ?? "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-2">
                        <div className="form-group mb-2">
                          <label className="mb-0">Total Kms</label>
                          <p className="labelvalue">
                            {state.rowData?.totalKms ?? 0}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-2">
                        <div className="form-group mb-2">
                          <label className="mb-0">ETA</label>
                          <p className="labelvalue">
                            {state.rowData?.etaDate
                              ? moment(state.rowData?.etaDate)
                                  .format(
                                    DefaultDateFormat.MomentDisplayDateTime24AMPFormat
                                  )
                                  ?.toString()
                              : "NA"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-lg-4">
                        <div className="form-group mb-2">
                          <label className="mb-0">Asset Name</label>
                          <p className="labelvalue">
                            {state.rowData?.allocatedAssetName ?? "NA"}
                          </p>
                        </div>
                      </div>

                      <div className="col-12 col-lg-2">
                        <div className="form-group mb-2">
                          <label className="mb-0">Start Time</label>
                          <p className="labelvalue">
                            {state.rowData?.startDate
                              ? moment(state.rowData?.startDate)
                                  .format(
                                    DefaultDateFormat.MomentDisplayDateTime24AMPFormat
                                  )
                                  ?.toString()
                              : "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-2">
                        <div className="form-group mb-2">
                          <label className="mb-0">End Time</label>
                          <p className="labelvalue">
                            {state.rowData?.endDate
                              ? moment(state.rowData?.endDate)
                                  .format(
                                    DefaultDateFormat.MomentDisplayDateTime24AMPFormat
                                  )
                                  ?.toString()
                              : "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-2">
                        <div className="form-group mb-2">
                          <label className="mb-0">Status</label>
                          <p className="labelvalue">
                            {state.rowData?.statusName ?? "NA"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-lg-8">
                        <div className="form-group mb-2">
                          <label className="mb-0">Current Location</label>
                          <p className="labelvalue">
                            {state.rowData?.currentDispatchLocation ?? "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-2">
                        <div className="form-group mb-2">
                          <label className="mb-0">Vehicle No</label>
                          <p className="labelvalue">
                            {state.rowData?.transportVehicle ?? "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-2">
                        <div className="form-group mb-2">
                          <label className="mb-0">Km Travelled</label>
                          <p className="labelvalue">
                            {dispatchTripDetails[0]?.lastCumulativeKm ?? 0}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-lg-12">
                        <div className="form-group mb-2">
                          {state.fromCoords && state.toCoords ? (
                            <>
                              {/* {isLoaded ? (
                                <> */}
                              <LoadScript
                                googleMapsApiKey={
                                  process.env.REACT_APP_GOOGLE_MAP_API_KEY
                                }
                                libraries={["geometry"]}
                              >
                                <GoogleMap
                                  mapContainerStyle={{
                                    width: "100%",
                                    height: "400px",
                                  }}
                                  onLoad={(map) => {
                                    const bounds =
                                      new window.google.maps.LatLngBounds();
                                    bounds.extend({
                                      lat: state.fromCoords
                                        ? state.fromCoords[0]
                                        : 0,
                                      lng: state.fromCoords
                                        ? state.fromCoords[1]
                                        : 0,
                                    });
                                    bounds.extend({
                                      lat: state.toCoords
                                        ? state.toCoords[0]
                                        : 0,
                                      lng: state.toCoords
                                        ? state.toCoords[1]
                                        : 0,
                                    });
                                    map.fitBounds(bounds);
                                    const path = [
                                      {
                                        lat: state.fromCoords[0],
                                        lng: state.fromCoords[1],
                                      },
                                      {
                                        lat: state.toCoords[0],
                                        lng: state.toCoords[1],
                                      },
                                    ];
                                    const totalDistance =
                                      window?.google?.maps?.geometry?.spherical?.computeLength(
                                        path
                                      );
                                    const points = [];
                                    for (
                                      let d = 0;
                                      d <= totalDistance;
                                      d += 500
                                    ) {
                                      const point =
                                        window?.google?.maps?.geometry?.spherical?.interpolate(
                                          path[0],
                                          path[1],
                                          d / totalDistance
                                        );
                                      points.push(point);
                                    }
                                    setArrowPoints(points);
                                  }}
                                >
                                  <Marker
                                    position={{
                                      lat: Number(
                                        state.rowData?.fromGeoLocation?.split(
                                          ","
                                        )[0]
                                      ),
                                      lng: Number(
                                        state.rowData?.fromGeoLocation?.split(
                                          ","
                                        )[1]
                                      ),
                                    }}
                                    onMouseOver={() => setIsOpen(true)}
                                    onMouseOut={() => setIsOpen(false)}
                                  >
                                    {isOpen && (
                                      <InfoWindow
                                        position={{
                                          lat: Number(
                                            state.rowData?.fromGeoLocation?.split(
                                              ","
                                            )[0]
                                          ),
                                          lng: Number(
                                            state.rowData?.fromGeoLocation?.split(
                                              ","
                                            )[1]
                                          ),
                                        }}
                                      >
                                        <div>
                                          {state.rowData?.transportVehicleNo}
                                        </div>
                                      </InfoWindow>
                                    )}
                                  </Marker>
                                  <Marker
                                    position={{
                                      lat: Number(
                                        state.rowData?.toGeoLocation?.split(
                                          ","
                                        )[0]
                                      ),
                                      lng: Number(
                                        state.rowData?.toGeoLocation?.split(
                                          ","
                                        )[1]
                                      ),
                                    }}
                                  />
                                  <Polyline
                                    path={[
                                      {
                                        lat: Number(
                                          state.rowData?.fromGeoLocation?.split(
                                            ","
                                          )[0]
                                        ),
                                        lng: Number(
                                          state.rowData?.fromGeoLocation?.split(
                                            ","
                                          )[1]
                                        ),
                                      },
                                      {
                                        lat: Number(
                                          state.rowData?.toGeoLocation?.split(
                                            ","
                                          )[0]
                                        ),
                                        lng: Number(
                                          state.rowData?.toGeoLocation?.split(
                                            ","
                                          )[1]
                                        ),
                                      },
                                    ]}
                                    options={{
                                      strokeColor: "#171b16ff",
                                      strokeOpacity: 0.4,
                                      strokeWeight: 4,
                                    }}
                                  />
                                  {arrowPoints?.map((point, i) => {
                                    const position = {
                                      lat: point.lat(),
                                      lng: point.lng(),
                                    };
                                    return (
                                      <Marker
                                        key={i}
                                        position={position}
                                        icon={{
                                          path: window?.google?.maps?.SymbolPath
                                            ?.CIRCLE,
                                          scale: 4,
                                          fillColor: "#29c21bff",
                                          fillOpacity: 1,
                                          strokeWeight: 0,
                                        }}
                                        onMouseOver={async () => {
                                          const name = await getLocationName(
                                            position.lat,
                                            position.lng
                                          );
                                          setActiveMarker(i);
                                          setActiveMarkerInfo({
                                            name,
                                            lat: position.lat,
                                            lng: position.lng,
                                          });
                                        }}
                                        onMouseOut={() => {
                                          setActiveMarker(null);
                                          setActiveMarkerInfo(null);
                                        }}
                                        onClick={async () => {
                                          const name = await getLocationName(
                                            position.lat,
                                            position.lng
                                          );
                                          setActiveMarker(i);
                                          setActiveMarkerInfo({
                                            name,
                                            lat: position.lat,
                                            lng: position.lng,
                                          });
                                        }}
                                      >
                                        {activeMarker === i &&
                                          activeMarkerInfo && (
                                            <InfoWindow
                                              position={position}
                                              onCloseClick={() => {
                                                setActiveMarker(null);
                                                setActiveMarkerInfo(null);
                                              }}
                                            >
                                              <div style={{ fontSize: "12px" }}>
                                                <br />
                                                Location Name:&nbsp;
                                                <strong>
                                                  {activeMarkerInfo.name}
                                                </strong>
                                                <br />
                                                Lat:&nbsp;
                                                <strong>
                                                  {position.lat.toFixed(5)}
                                                </strong>
                                                <br />
                                                Lng:&nbsp;
                                                <strong>
                                                  {position.lng.toFixed(5)}
                                                </strong>
                                              </div>
                                            </InfoWindow>
                                          )}
                                      </Marker>
                                    );
                                  })}
                                </GoogleMap>
                              </LoadScript>
                              {/* </>
                              ) : (
                                <>
                                  <h6>Loading map...</h6>
                                </>
                              )} */}
                            </>
                          ) : (
                            <>
                              <h6>No Data Found!!</h6>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            </Item>
            <Item title="Add Dispatch Details" icon="add">
              <>
                <div className="row content-header">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="row">
                      <div className="col-12 col-lg-5">
                        <div className="form-group mb-2">
                          <label className="mb-0">From Location</label>
                          <p className="labelvalue">
                            {state.rowData?.fromDispatchLocation ?? "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-5">
                        <div className="form-group mb-2">
                          <label className="mb-0">To Location</label>
                          <p className="labelvalue">
                            {state.rowData?.toDispatchLocation ?? "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-2">
                        <div className="form-group mb-2">
                          <label className="mb-0">Vehicle No</label>
                          <p className="labelvalue">
                            {state.rowData?.transportVehicle ?? "NA"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <br />
                    {dispatchTripDetails[0]?.totalKms > 0 &&
                      dispatchTripDetails[0]?.etaDate && (
                        <>
                          <div className="row">
                            <div className="col-12 col-lg-3">
                              <div className="form-group mb-2">
                                <label>
                                  Total Kms
                                  {isClickOnTotalKm && (
                                    <>
                                      &nbsp;
                                      <span className="text-danger">*</span>
                                    </>
                                  )}
                                </label>
                                {!isClickOnTotalKm ? (
                                  <>
                                    &nbsp;- &nbsp;&nbsp;
                                    <Link
                                      onClick={(e) => {
                                        e.preventDefault();
                                        try {
                                          setIsClickOnTotalKm(true);
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}
                                    >
                                      <i className="fas fa-edit"></i>
                                      &nbsp;&nbsp;
                                      <u>
                                        <span>
                                          {Number(state.totalKm ?? 0) || ""}
                                        </span>
                                      </u>
                                    </Link>
                                  </>
                                ) : (
                                  <>
                                    &nbsp;&nbsp;
                                    <Link
                                      onClick={(e) => {
                                        e.preventDefault();
                                        try {
                                          setIsClickOnTotalKm(false);
                                          setState((prevState) => ({
                                            ...prevState,
                                            totalKm:
                                              dispatchTripDetails[0]?.totalKms,
                                          }));
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}
                                    >
                                      Back
                                    </Link>
                                    &nbsp;&nbsp;
                                    <Link
                                      onClick={async (e) => {
                                        await handleOnResubmitDispatchDetails(
                                          e
                                        );
                                      }}
                                    >
                                      Update
                                    </Link>
                                  </>
                                )}
                                {isClickOnTotalKm && (
                                  <>
                                    <NumberBox
                                      name="totalKm"
                                      className="form-control form-control-sm"
                                      height={37}
                                      placeholder="Enter total km"
                                      showClearButton={true}
                                      valueChangeEvent="keyup"
                                      onValueChanged={(e) => {
                                        let err = { ...errors };
                                        err.totalKmValidation = "";
                                        setErrors(err);
                                        setState((prev) => ({
                                          ...prev,
                                          totalKm: e.value ?? "",
                                        }));
                                      }}
                                      value={Number(state.totalKm ?? 0) || ""}
                                    />
                                    {errors.totalKmValidation && (
                                      <div className="text-danger">
                                        {errors.totalKmValidation}
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                            <div className="col-12 col-lg-3">
                              <div className="form-group mb-2">
                                <label>
                                  ETA
                                  {isClickOnEtaDate && (
                                    <>
                                      &nbsp;
                                      <span className="text-danger">*</span>
                                    </>
                                  )}
                                </label>
                                {!isClickOnEtaDate ? (
                                  <>
                                    &nbsp;- &nbsp;&nbsp;
                                    <Link
                                      onClick={(e) => {
                                        e.preventDefault();
                                        try {
                                          setIsClickOnEtaDate(true);
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}
                                    >
                                      <i className="fas fa-edit"></i>
                                      &nbsp;&nbsp;
                                      <u>
                                        <span>{state.eta}</span>
                                      </u>
                                    </Link>
                                  </>
                                ) : (
                                  <>
                                    &nbsp;&nbsp;
                                    <Link
                                      onClick={(e) => {
                                        e.preventDefault();
                                        try {
                                          setIsClickOnEtaDate(false);
                                          setState((prevState) => ({
                                            ...prevState,
                                            eta: dispatchTripDetails[0]
                                              ?.etaDate,
                                          }));
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}
                                    >
                                      Back
                                    </Link>
                                    &nbsp;&nbsp;
                                    <Link
                                      onClick={async (e) => {
                                        await handleOnResubmitDispatchDetails(
                                          e
                                        );
                                      }}
                                    >
                                      Update
                                    </Link>
                                  </>
                                )}
                                {isClickOnEtaDate && (
                                  <>
                                    <DateBox
                                      type="datetime"
                                      className="form-control"
                                      name="eta"
                                      placeholder={
                                        DefaultDateFormat.DateTime24Format
                                      }
                                      displayFormat={
                                        DefaultDateFormat.DateTime24Format
                                      }
                                      showAnalogClock={true}
                                      useMaskBehavior={false}
                                      defaultValue={state.eta}
                                      value={state.eta}
                                      disabled={false}
                                      acceptCustomValue={true}
                                      onValueChanged={(date) => {
                                        let err = { ...errors };
                                        err.etaValidation = "";
                                        setErrors(err);
                                        setState((prev) => ({
                                          ...prev,
                                          eta: date.value,
                                        }));
                                      }}
                                    />
                                    {errors.etaValidation && (
                                      <div className="text-danger">
                                        {errors.etaValidation}
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    <div className="row">
                      <div className="col-12 col-lg-12">
                        <div className="form-group mb-2">
                          <DataGrid
                            dataSource={dispatchTripDetails}
                            showColumnLines={false}
                            showRowLines={true}
                            showBorders={true}
                            allowColumnResizing={false}
                            allowColumnReordering={true}
                            columnAutoWidth={true}
                          >
                            <Column
                              dataField="entryDate"
                              caption="Entry Time"
                              allowSearch={true}
                              allowFiltering={false}
                              allowSorting={true}
                              dataType="datetime"
                              format={DefaultDateFormat.GridDateTime24Format}
                            />
                            <Column
                              dataField="currentDispatchLocation"
                              caption="Current Location"
                              allowSearch={true}
                              allowFiltering={false}
                              allowSorting={true}
                              width={385}
                            />
                            <Column
                              dataField="lastKms"
                              caption="Km Travelled"
                              alignment={"center"}
                              allowSearch={true}
                              allowFiltering={false}
                              allowSorting={true}
                            />
                            <Column
                              dataField="cumulativeKm"
                              caption="Cumulative Kms"
                              alignment={"center"}
                              allowSearch={true}
                              allowFiltering={false}
                              allowSorting={true}
                            />
                            <Column
                              dataField="travelDuration"
                              caption="Travel Duration"
                              allowSearch={true}
                              allowFiltering={false}
                              allowSorting={true}
                            />
                            <HeaderFilter visible={false} />
                            <SearchPanel
                              visible={true}
                              highlightCaseSensitive={true}
                              width={240}
                              placeholder="Search..."
                            />
                          </DataGrid>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div className="row">
                      {dispatchTripDetails[0]?.fromDispatchLocation &&
                        dispatchTripDetails[0]?.toDispatchLocation && (
                          <>
                            <div className="col-12 col-lg-4">
                              <div className="form-group mb-2">
                                <label>
                                  Current Location&nbsp;
                                  <span className="text-danger">*</span>
                                </label>
                                <Autocomplete
                                  dataSource={state.currentLocationResult?.map(
                                    (s) => s.name + " - " + s.address
                                  )}
                                  placeholder="Search current location..."
                                  displayExpr={function (items) {
                                    return (
                                      items &&
                                      items?.name +
                                        " - " +
                                        `(${items?.address})`
                                    );
                                  }}
                                  defaultValue={state.currentLocation}
                                  onValueChange={async (e) => {
                                    await handleOnCurrentLocationSearch(e);
                                  }}
                                  onItemClick={async (e) =>
                                    await handleOnCurrentLocationSelection(
                                      e.itemData
                                    )
                                  }
                                  minSearchLength={0}
                                  searchTimeout={400}
                                />
                                {errors.currentLocationValidation && (
                                  <div className="text-danger">
                                    {errors.currentLocationValidation}
                                  </div>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                      {!dispatchTripDetails[0]?.fromDispatchLocation &&
                        !dispatchTripDetails[0]?.toDispatchLocation && (
                          <>
                            <div className="col-12 col-lg-4">
                              <div className="form-group mb-2">
                                <label>
                                  From Location&nbsp;
                                  <span className="text-danger">*</span>
                                </label>
                                <Autocomplete
                                  dataSource={state.fromLocationResult?.map(
                                    (s) => s.name + " - " + s.address
                                  )}
                                  placeholder="Search from location..."
                                  displayExpr={function (items) {
                                    return (
                                      items &&
                                      items?.name +
                                        " - " +
                                        `(${items?.address})`
                                    );
                                  }}
                                  //displayExpr="address"
                                  defaultValue={state.fromLocation}
                                  onValueChange={async (e) => {
                                    await handleOnFromLocationSearch(e);
                                  }}
                                  onItemClick={async (e) =>
                                    await handleOnFromLocationSelection(
                                      e.itemData
                                    )
                                  }
                                  minSearchLength={0}
                                  searchTimeout={400}
                                />
                                {errors.fromLocationValidation && (
                                  <div className="text-danger">
                                    {errors.fromLocationValidation}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-12 col-lg-4">
                              <div className="form-group mb-2">
                                <label>
                                  To Location&nbsp;
                                  <span className="text-danger">*</span>
                                </label>
                                <Autocomplete
                                  dataSource={state.toLocationResult?.map(
                                    (s) => s.name + " - " + s.address
                                  )}
                                  displayExpr={function (items) {
                                    return (
                                      items &&
                                      items?.name +
                                        " - " +
                                        `(${items?.address})`
                                    );
                                  }}
                                  defaultValue={state.toLocation}
                                  placeholder="Search to location..."
                                  onValueChange={async (e) => {
                                    await handleOnToLocationSearch(e);
                                  }}
                                  onItemClick={async (e) =>
                                    await handleOnToLocationSelection(
                                      e.itemData
                                    )
                                  }
                                  minSearchLength={0}
                                  searchTimeout={400}
                                />
                                {errors.toLocationValidation && (
                                  <div className="text-danger">
                                    {errors.toLocationValidation}
                                  </div>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                      {dispatchTripDetails[0]?.totalKms > 0 && (
                        <>
                          <div className="col-12 col-lg-4">
                            <div className="form-group mb-2">
                              <label>
                                Kms Travelled&nbsp;
                                <span className="text-danger">*</span>
                              </label>
                              <NumberBox
                                name="lastKm"
                                className="form-control form-control-sm"
                                height={37}
                                placeholder="Enter kms travelled"
                                showClearButton={true}
                                valueChangeEvent="keyup"
                                format="#"
                                onValueChanged={(e) => {
                                  let err = { ...errors };
                                  err.lastKmValidation = "";
                                  setErrors(err);
                                  setState((prev) => ({
                                    ...prev,
                                    lastKm: e.value ?? "",
                                  }));
                                }}
                                value={Number(state.lastKm ?? 0) || ""}
                              />
                              {errors.lastKmValidation && (
                                <div className="text-danger">
                                  {errors.lastKmValidation}
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      {!dispatchTripDetails[0]?.fromDispatchLocation &&
                        !dispatchTripDetails[0]?.toDispatchLocation && (
                          <>
                            <div className="col-12 col-lg-4">
                              <div className="form-group mb-2">
                                <label>
                                  Total Kms&nbsp;
                                  <span className="text-danger">*</span>
                                </label>
                                <NumberBox
                                  name="totalKm"
                                  className="form-control form-control-sm"
                                  height={37}
                                  placeholder="Enter total km"
                                  showClearButton={true}
                                  valueChangeEvent="keyup"
                                  onValueChanged={(e) => {
                                    let err = { ...errors };
                                    err.totalKmValidation = "";
                                    setErrors(err);
                                    setState((prev) => ({
                                      ...prev,
                                      totalKm: e.value ?? "",
                                    }));
                                  }}
                                  value={Number(state.totalKm ?? 0) || ""}
                                />
                                {errors.totalKmValidation && (
                                  <div className="text-danger">
                                    {errors.totalKmValidation}
                                  </div>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                      <div className="col-12 col-lg-4">
                        <div className="form-group mb-2">
                          <label>
                            Entry Time&nbsp;
                            <span className="text-danger">*</span>
                          </label>
                          <DateBox
                            type="datetime"
                            className="form-control"
                            name="entryTime"
                            placeholder={DefaultDateFormat.DateTime24Format}
                            displayFormat={DefaultDateFormat.DateTime24Format}
                            showAnalogClock={true}
                            useMaskBehavior={false}
                            defaultValue={state.entryTime}
                            value={state.entryTime}
                            disabled={false}
                            acceptCustomValue={true}
                            onValueChanged={(date) => {
                              let err = { ...errors };
                              err.entryTimeValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                entryTime: date.value,
                              }));
                            }}
                          />
                          {errors.entryTimeValidation && (
                            <div className="text-danger">
                              {errors.entryTimeValidation}
                            </div>
                          )}
                        </div>
                      </div>
                      {!dispatchTripDetails[0]?.etaDate && (
                        <>
                          <div className="col-12 col-lg-4">
                            <div className="form-group mb-2">
                              <label>
                                ETA&nbsp;<span className="text-danger">*</span>
                              </label>
                              <DateBox
                                type="datetime"
                                className="form-control"
                                name="eta"
                                placeholder={DefaultDateFormat.DateTime24Format}
                                displayFormat={
                                  DefaultDateFormat.DateTime24Format
                                }
                                showAnalogClock={true}
                                useMaskBehavior={false}
                                defaultValue={state.eta}
                                value={state.eta}
                                disabled={false}
                                acceptCustomValue={true}
                                onValueChanged={(date) => {
                                  let err = { ...errors };
                                  err.etaValidation = "";
                                  setErrors(err);
                                  setState((prev) => ({
                                    ...prev,
                                    eta: date.value,
                                  }));
                                }}
                              />
                              {errors.etaValidation && (
                                <div className="text-danger">
                                  {errors.etaValidation}
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    title="Submit"
                    onClick={async (e) => {
                      await handleOnSaveDispatchDetails(e);
                    }}
                    disabled={state.isSubmitted}
                  >
                    <span title="Submit">
                      <i
                        className={`fas fa-${
                          state.isSubmitted ? `spinner fa-spin` : `check`
                        }`}
                      />
                      &nbsp;&nbsp;Submit
                    </span>
                  </button>
                  &nbsp;&nbsp;
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    title="Cancel"
                    onClick={() => {
                      handleOnCloseTrackingModal();
                    }}
                  >
                    <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
                  </button>
                </div>
              </>
            </Item>
          </TabPanel>
        </div>
      </Modal>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
